/* eslint-disable max-len */
import { mapBy } from '../lib/functional';

export const STRIPE_TAX_CODES = [
  {
    id: 'txcd_99999999',
    type: 'physical',
    performanceLocationRequirement: 'none',
    description:
      'A physical good that can be moved or touched. Also known as tangible personal property.',
    name: 'General - Tangible Goods',
  },
  {
    id: 'txcd_20030000',
    type: 'services',
    performanceLocationRequirement: 'none',
    description:
      "General category for services. Only use this if you don't have a more specific category. You should set specific tax codes on each product or service you sell. EU only: Business-to-consumer sales are taxable at origin; business-to-business are taxable at destination.",
    name: 'General - Services',
  },
  {
    id: 'txcd_00000000',
    type: 'physical',
    performanceLocationRequirement: 'none',
    description:
      'Any nontaxable good or service which can be used to ensure no tax is applied, even for jurisdictions that impose a tax.',
    name: 'Nontaxable',
  },
  {
    id: 'txcd_10502000',
    type: 'digital',
    performanceLocationRequirement: 'none',
    description:
      'Gift card or gift certificate that you purchase and receive electronically and assumed to be multi-purpose.',
    name: 'Gift Card',
  },
  {
    id: 'txcd_20030004',
    type: 'services',
    performanceLocationRequirement: 'none',
    description: 'A charge for providing usage of a parking space.',
    name: 'Parking Services',
  },
  {
    id: 'txcd_20040001',
    type: 'services',
    performanceLocationRequirement: 'none',
    description:
      'Services provided by beauty shops and barber shops, including but not limited to haircutting, hair coloring, shampooing, blow drying, permanents, hair extensions, hair straightening, and hair restorations.',
    name: 'Hairdressing Services',
  },
  {
    id: 'txcd_20040002',
    type: 'services',
    performanceLocationRequirement: 'none',
    description:
      'A charge for personal care services. Please select a more granular product tax category where appropriate.',
    name: 'Personal Care Services',
  },
  {
    id: 'txcd_20040004',
    type: 'services',
    performanceLocationRequirement: 'none',
    description:
      'Services that provide non-medical care and supervision for infant to school-age children or senior citizens.',
    name: 'Childcare Services / Adultcare',
  },
  {
    id: 'txcd_20040007',
    type: 'services',
    performanceLocationRequirement: 'none',
    description:
      'A charge for the cosmetic beauty treatment for the fingernails and toenails, including filing, cutting, shaping and the application of polish.',
    name: 'Manicure Services',
  },
  {
    id: 'txcd_20040008',
    type: 'services',
    performanceLocationRequirement: 'none',
    description:
      'Services where the use of structured touch, include holding, applying pressure, positioning, and mobilizing soft tissue of the body by manual technique. Note: This does not include medical massage prescribed by a physician.',
    name: 'Massage Services',
  },
  {
    id: 'txcd_20040009',
    type: 'services',
    performanceLocationRequirement: 'none',
    description:
      'Personal services typically with the purpose of improving health, beauty and relaxation through treatments such as hair, massages and facials.',
    name: 'Spa Services',
  },
  {
    id: 'txcd_20040010',
    type: 'services',
    performanceLocationRequirement: 'none',
    description: 'Services for artificial tanning and skin beautification.',
    name: 'Tanning Services',
  },
  {
    id: 'txcd_20040011',
    type: 'services',
    performanceLocationRequirement: 'none',
    description:
      "A charge for the process that uses needles and colored ink to permanently put a mark or design on a person's skin.",
    name: 'Tattooing Services',
  },
  {
    id: 'txcd_20060000',
    type: 'services',
    performanceLocationRequirement: 'none',
    description:
      'A charge for a service performed by providers considered professionals due to the extensive initial and continuing education and/or training requirements, and the likelihood of state or federal licensing requirements.',
    name: 'Professional Services',
  },
  {
    id: 'txcd_30071000',
    type: 'physical',
    performanceLocationRequirement: 'none',
    description:
      'Protective gear worn about the human body while participating in athletic, recreational, or sporting activities, and which are not typical for everyday usage.',
    name: 'Sports Activities Equipment',
  },
  {
    id: 'txcd_50010001',
    type: 'events',
    performanceLocationRequirement: 'none',
    description:
      'Charges for admission to amusement, recreation, or entertainment venues where the entrant participates in activities, excluding sports activities.',
    name: 'Admission to Amusement, Entertainment & Recreation Venues – Participant',
  },
  {
    id: 'txcd_50010002',
    type: 'events',
    performanceLocationRequirement: 'none',
    description:
      'Charges for admission to sports facilities, other than gyms/fitness centers, where the entrant participates in recreational athletic pursuits.',
    name: 'Admission to Sporting Facilities - Participant',
  },
  {
    id: 'txcd_50021003',
    type: 'services',
    performanceLocationRequirement: 'none',
    description:
      'Charges associated with the service of providing in-person personal fitness training or group exercise classes.',
    name: 'Fee for Personal Training/Fitness Classes',
  },
  {
    id: 'txcd_50021101',
    type: 'services',
    performanceLocationRequirement: 'none',
    description:
      'Charges associated with one-time access for use of health clubs and fitness clubs.',
    name: 'Fitness Centers - Single Use Access Fees',
  },
  {
    id: 'txcd_50021103',
    type: 'services',
    performanceLocationRequirement: 'none',
    description:
      'Charges associated with the service of providing in-person instruction in an athletic pursuit.',
    name: 'Fee For Sport Instruction Classes',
  },
  {
    id: 'txcd_90000001',
    type: 'physical',
    performanceLocationRequirement: 'none',
    description: 'A monetary donation for a cause, in which the donee receives nothing in return.',
    name: 'Cash Donation',
  },
  {
    id: 'txcd_90020001',
    type: 'services',
    performanceLocationRequirement: 'none',
    description:
      'Gratuity, otherwise known as a tip, is money that a customer leaves for an employee or employees that is in addition to and separate from the amount due for the goods or services rendered.',
    name: 'Optional Gratuity',
  },
];

export const STRIPE_TAX_CODES_MAP = mapBy(STRIPE_TAX_CODES, tc => tc.id);
